import { useTheme } from '@emotion/react';
import * as React from 'react';
import { ArrowDownIcon } from '../../../components/Icons/ArrowDownIcon';
import { FlagIcon } from '../../../components/Icons/FlagIcon';
import { darkAcqa, darkGray, gray, white } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { tableStyles } from './WaypointsTable';

const styles: Record<string, React.CSSProperties> = {
    day: {
        marginRight: 2,
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    flag: {
        fill: darkAcqa,
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    arrow: {
        transition: 'transform 0.15s ease-in-out',
        fill: darkAcqa,
    },
    borderStyle: {
        position: 'absolute',
        bottom: 0,
        width: 0,
        height: 0,
        left: 60,
        border: 0,
        background: white,
        transform: 'rotate(-45deg)',
        transition: 'all 0.15s ease-in-out',
    },
    portOfEmbarkationStyle: {
        display: 'inline-block',
        color: darkGray,
    },
};
interface IProps {
    index: number;
    day: number;
    title: string;
    isPortOfDisembarkation: boolean;
    isPortOfEmbarkation: boolean;
    info: string[];
    collapsed: boolean;
    isLastRow: boolean;
    onClick(index: number): void;
    isSeeDay: boolean;
    isEmbarked: boolean;
}

export function WaypointRowHeader(props: IProps) {
    const {
        day,
        title,
        isPortOfDisembarkation,
        isPortOfEmbarkation,
        onClick,
        collapsed,
        index,
        info,
        isEmbarked,
    } = props;
    const theme = useTheme();
    const arrowStyle: any = {
        transform: collapsed ? 'rotate(0deg)' : 'rotate(-180deg)',
    };
    const arrowColorStyles = {
        fill: theme.icon.brandColor1,
    };
    const noBorderStyle: any = props.isLastRow ? { borderBottom: 0 } : {};
    const wrapperStyle: any = {
        ...noBorderStyle,
        marginBottom: collapsed ? 0 : 20,
    };
    const borderArrowStyle: any = collapsed
        ? styles.borderStyle
        : {
              ...styles.borderStyle,
              width: 20,
              height: 20,
              bottom: -10,
              left: 50,
              border: `1px solid ${gray}`,
              borderTop: 0,
              borderRight: 0,
          };

    const handleClick = () => {
        if (props.isSeeDay || typeof onClick !== 'function') {
            return null;
        } else {
            onClick(index);
        }
    };

    let extraInfo: string[] = [];
    if (isPortOfDisembarkation) {
        extraInfo.push(__('Disembarkment', 'dreamlines'));
    }
    if (info?.length > 0) {
        extraInfo.push(
            ...info.filter((inf) => {
                if (inf === 'Übernachtung an Bord') {
                    if (!isEmbarked) {
                        return false;
                    }
                } else {
                    return inf;
                }
            }),
        );
    }
    if (isPortOfEmbarkation) {
        extraInfo.push(__('Embarkment', 'dreamlines'));
    }
    if (!isEmbarked && info?.includes('Übernachtung an Bord')) {
        extraInfo.push('Übernachtung an Bord');
    }
    return (
        <div style={{ ...tableStyles.row, ...wrapperStyle }} onClick={handleClick}>
            {!props.isLastRow && <div style={borderArrowStyle}></div>}
            <div style={tableStyles.col1}>
                <span style={styles.day}>{day}</span>
                {Boolean(isPortOfDisembarkation || isPortOfEmbarkation) && (
                    <FlagIcon width={14} height={14} style={styles.flag} />
                )}
            </div>
            <div style={tableStyles.col2}>
                {__(title, 'dreamlines')}
                <div style={styles.portOfEmbarkationStyle}>{extraInfo.join(', ')}</div>
            </div>
            <div style={tableStyles.col3}>
                {!props.isSeeDay && typeof onClick === 'function' && (
                    <ArrowDownIcon
                        width={16}
                        height={16}
                        style={{ ...styles.arrow, ...arrowStyle, ...arrowColorStyles }}
                    />
                )}
            </div>
        </div>
    );
}
